"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productIndexSettingsConfig = void 0;
const defaultAlgoliaIndex_config_1 = require("../defaultAlgoliaIndex.config");
const schemaName_1 = require("../schemaName");
exports.productIndexSettingsConfig = {
    schemaName: schemaName_1.SchemaName.product,
    settings: (language) => (Object.assign(Object.assign(Object.assign(Object.assign({}, defaultAlgoliaIndex_config_1.defaultAlgoliaIndexConfig), defaultAlgoliaIndex_config_1.defaultPageFieldConfig), (0, defaultAlgoliaIndex_config_1.defaultIndexLanguageConfig)(language)), { searchableAttributes: [
            'unordered(category)',
            'unordered(name)',
            'unordered(description)',
            'unordered(keywords)',
            'unordered(occasions)',
            'unordered(format)',
            'contents.pip'
        ], attributesForFaceting: [
            ...defaultAlgoliaIndex_config_1.defaultPageFieldConfig.attributesForFaceting,
            'inStock',
            'price.value'
        ], disableTypoToleranceOnAttributes: [
            'contents.pip'
        ], ranking: [
            'desc(inStock)',
            ...defaultAlgoliaIndex_config_1.defaultPageFieldConfig.ranking
        ], reRankingApplyFilter: [
            'inStock:true'
        ] }))
};
